import { yup } from '@framework/validation';
import { fromPairs } from 'lodash';
import { FormBuilderMetaFlags } from '../../../../../validator';
import { ICreateWidgetFormSchemaInput } from '../../../IWidgetType';
import { getDatatypeOutputSchema } from '../../common/async-widgets/getDatatypeOutputSchema';
import { asyncSelectWidgetObjectName } from '../async-select/hooks/asyncSelectObjectName';
import { IAsyncTableWidget } from './IAsyncTableWidget';

export function createAsyncTableFormSchema(
  input: ICreateWidgetFormSchemaInput<IAsyncTableWidget>,
) {
  const { widget } = input;

  const outputs = widget.outputs ?? [];

  const objectSchema = yup
    .array()
    .of(
      yup.object(
        fromPairs(
          outputs.map(output => [
            output.name,
            getDatatypeOutputSchema(output.type),
          ]),
        ),
      ),
    )
    .formBuilderFlags(
      FormBuilderMetaFlags.SkipDefaultValue,
      FormBuilderMetaFlags.SkipValidationRules,
    );
  return {
    [asyncSelectWidgetObjectName(widget.code)]: objectSchema.notRequired(),
  };
}
